export default __webpack_public_path__ + "static/media/emailfound.ea46fea5.svg";